import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, IconButton, Tooltip } from '@mui/material';
import { IHeaderParams } from 'ag-grid-community';
import { MouseEvent, useCallback, useEffect, useState } from 'react';

export function ExpandAllHeader(props: IHeaderParams) {
  const { api, displayName } = props;
  const [allExpanded, setAllExpanded] = useState(false);
  const [hasMaster, setHasMaster] = useState(false);

  const recompute = useCallback(() => {
    let total = 0;
    let expanded = 0;
    api.forEachNode((node) => {
      if (node.master) {
        total += 1;
        if (node.expanded) {
          expanded += 1;
        }
      }
    });
    setHasMaster(total > 0);
    setAllExpanded(total > 0 && total === expanded);
  }, [api]);

  useEffect(() => {
    recompute();
    const listener = () => recompute();
    api.addEventListener('rowGroupOpened', listener);
    api.addEventListener('modelUpdated', listener);
    return () => {
      api.removeEventListener('rowGroupOpened', listener);
      api.removeEventListener('modelUpdated', listener);
    };
  }, [api, recompute]);

  const handleToggle = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const target = !allExpanded;
    api.forEachNode((node) => {
      if (node.master) {
        node.setExpanded(target);
      }
    });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', width: '100%' }}>
      <Tooltip title={allExpanded ? 'Collapse all' : 'Expand all'}>
        <span>
          <IconButton
            size='small'
            onClick={handleToggle}
            disabled={!hasMaster}
            sx={{ padding: '2px' }}
            aria-label={allExpanded ? 'Collapse all rows' : 'Expand all rows'}
          >
            <ExpandMoreIcon
              sx={{
                fontSize: 18,
                transform: allExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
                transition: 'transform 0.15s',
              }}
            />
          </IconButton>
        </span>
      </Tooltip>
      <span>{displayName}</span>
    </Box>
  );
}
